import {
  twind_config_default
} from "./chunk-JJJXAZF2.js";
import "./chunk-JA3MEJAB.js";

// src/twind.ts
import install from "@twind/with-react";
import {
  twind,
  virtual,
  cssom,
  tx as tx$,
  css as css$,
  style as style$,
  apply as apply$,
  injectGlobal as injectGlobal$,
  keyframes as keyframes$,
  observe as observe$
} from "@twind/core";
import { getSheet, parse, parseValue } from "@twind/core";
import { default as default2 } from "@twind/with-react/inline";
var colors = twind_config_default.theme.colors;
function isProd() {
  if (typeof import.meta.env !== "undefined") {
    return import.meta.env.PROD ?? false;
  } else if (typeof process !== "undefined" && typeof process.env !== "undefined") {
    return process.env.NODE_ENV === "production";
  }
  return false;
}
var sheet = typeof document === "undefined" ? virtual() : cssom("style[data-library]");
var tw = /* @__PURE__ */ twind(
  twind_config_default,
  // support SSR and use a different selector to not get the twind default style sheet
  sheet
);
function setupTwindReact(prod = isProd()) {
  install(twind_config_default, prod);
  if (typeof globalThis.addEventListener === "function") {
    globalThis.addEventListener("warning", (event) => {
      const warning = event.detail;
      if (warning?.code === "TWIND_INVALID_CLASS") {
        event.preventDefault();
      }
    });
  }
}
var tx = /* @__PURE__ */ tx$.bind(tw);
var css = /* @__PURE__ */ css$.bind(tw);
var style = /* @__PURE__ */ style$.bind(tw);
var apply = /* @__PURE__ */ apply$.bind(tw);
var observe = /* @__PURE__ */ observe$.bind(tw);
var injectGlobal = /* @__PURE__ */ injectGlobal$.bind(tw);
var keyframes = /* @__PURE__ */ keyframes$.bind(tw);
export {
  apply,
  colors,
  css,
  getSheet,
  injectGlobal,
  default2 as inline,
  keyframes,
  observe,
  parse,
  parseValue,
  setupTwindReact,
  sheet,
  style,
  tw,
  tx
};
//# sourceMappingURL=twind.js.map